import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../../utils/getConfig.js';
import { HelpDrawerDocSkeleton, PageID } from './types.js';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

async function getEntries(pageID: PageID | null) {
  const entryItems = await client.getEntries<HelpDrawerDocSkeleton>({
    content_type: 'helpDrawerDocument',
    limit: 1,
    'fields.pageId[match]': pageID ?? undefined,
  });

  return entryItems.items;
}

export function useHelpDrawerDoc({ pageID }: { pageID: PageID | null }) {
  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery(['helpDrawerDoc', pageID], () => getEntries(pageID), { enabled: !!pageID });

  return { document: data[0] ?? null, isLoading, isError, error };
}
